import React from 'react';
import { MAP_ELEMENT } from "../../../../contexts/WorldMapContext/constants";
import { selectDashboard, selectViewMode } from '../../../../util/store/selectors';
import { useSelector } from "../../../../util/store/store";
import { VIEW_MODE } from "../../../../util/varibles/permission";
import { EL_DASHBOARD } from "../constants";
import styles from '../style.module.scss';
import DiseasedZone from "./DiseasedZone";
import Factory from "./Factory";
import Operations from "./Operations";
import Poi from "./Poi";
import Site from "./Site";
import Toggle from "./Toggle";
import Vessel from "./Vessel";

interface IProps {
}

const LeftControl: React.FC<IProps> = () => {
    const viewMode = useSelector(selectViewMode);
    const target = useSelector(selectDashboard.target);
    if ((!target.targetType || target.targetType === MAP_ELEMENT.POLYLINE) && viewMode === VIEW_MODE.VESSEL)
        return null;

    function renderContent() {
        const props = target

        switch (target.targetType) {
            case MAP_ELEMENT.VESSEL:
                return <Vessel {...props} />;
            case MAP_ELEMENT.SITE:
                return <Site {...props} />;
            case MAP_ELEMENT.FACTORY:
                return <Factory {...props} />;
            case MAP_ELEMENT.DISEASED_ZONE:
                return <DiseasedZone {...props} />
            case MAP_ELEMENT.POI:
                return <Poi {...props} />
            default:
                return <Operations />;
        }
    }

    return <div id={EL_DASHBOARD.LEFT_CONTROL} className={styles.controlLeft}>
        {renderContent()}
        <Toggle />
    </div>;
};
export default LeftControl;

